import React from "react";
import { Navigate } from "react-router";
import { useUser } from "../../contexts/UserContext";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useScopeParams } from "@/hooks/useScopeParams";

type FeatureFlagWrapperProps = {
  children: React.ReactNode;
  componentFlag: string | string[];
  fallbackComponent?: React.ReactNode;
  goToNotFound?: boolean;
  anyTrialFeature?: boolean;
};

function FeatureFlagWrapper({
  children,
  componentFlag,
  fallbackComponent,
  goToNotFound,
  anyTrialFeature,
}: FeatureFlagWrapperProps) {
  const { userInfo } = useUser();
  const { buildUrl } = useScopeParams();
  const isFlagEnabled = useFeatureFlag(componentFlag, anyTrialFeature);

  if (!userInfo) return null;

  if (isFlagEnabled) {
    return <div>{children}</div>;
  }

  if (fallbackComponent) {
    return fallbackComponent;
  }

  if (goToNotFound) {
    return <Navigate to={buildUrl("404")} />;
  }

  return null;
}

export default FeatureFlagWrapper;
